// extracted by mini-css-extract-plugin
export default {"cursor-pointer":"inputField_cursor-pointer__aPCcu"};